/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/toggle/custom-elements';

import { defineCustomElement as defineOsdsToggle } from '@ovhcloud/ods-stencil/components/toggle/custom-elements/osds-toggle.js';

export const OsdsToggle = /*@__PURE__*/createReactComponent<JSX.OsdsToggle, HTMLOsdsToggleElement>('osds-toggle', undefined, undefined, defineOsdsToggle);
